// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__33QzP","name":"Header_name__1yzBa","birthday":"Header_birthday__3we-8","skeleton":"Header_skeleton__2lZao"};